<template>
    <div>
        <loading-custom :loading="loading" />
        <div class="card">
            <div class="card-body">
                <div class="form-group row">
                    <div class="col-lg-4 col-md-4">
                        <label>Google Tag Manager</label>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <input
                            v-model="form.google_tag"
                            name="google_tag"
                            type="text"
                            class="form-control tw-placeholder-gray-300 col-lg-6"
                            placeholder="GTM-XXXXXXX"
                        />
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-lg-4 col-md-4">
                        <label>Google Analytic 4 MEASUREMENT ID</label>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <input
                            v-model="form.google_analytic"
                            name="google_analytic"
                            type="text"
                            class="form-control tw-placeholder-gray-300 col-lg-6"
                            placeholder="G-XXXXXXXXXX"
                        />
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-lg-4 col-md-4">
                        <label>Facebook Pixel</label>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <input
                            v-model="form.facebook_pixel"
                            name="facebook_pixel"
                            type="text"
                            class="form-control tw-placeholder-gray-300 col-lg-6"
                            placeholder="xxxxxxxxxxxxxxx"
                        />
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-lg-4 col-md-4">
                        <label>TikTok Pixel</label>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <input
                            v-model="form.tiktok_pixel"
                            name="tiktok_pixel"
                            type="text"
                            class="form-control tw-placeholder-gray-300 col-lg-6"
                            placeholder="xxxxxxxxxxxxxxxxxxxx"
                        />
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-lg-4 col-md-4">
                        <label>Line Tag</label>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <input
                            v-model="form.line_tag"
                            name="line_tag"
                            type="text"
                            class="form-control tw-placeholder-gray-300 col-lg-6"
                            placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
                        />
                    </div>
                </div>
            </div>

            <div class="card-footer flex-row-reverse tw-bg-white px-0">
                <div class="col-lg-12 p-0">
                    <div class="d-flex flex-row-reverse">
                        <button
                            type="button"
                            class="btn btn-sm btn-success"
                            @click="store"
                        >
                            บันทึก
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["shop", "salePage"],

    data() {
        return {
            loading: false,
            form: {
                google_tag: this.salePage.scripts?.google_tag || "",
                google_analytic: this.salePage.scripts?.google_analytic || "",
                facebook_pixel: this.salePage.scripts?.facebook_pixel || "",
                tiktok_pixel: this.salePage.scripts?.tiktok_pixel || "",
                line_tag: this.salePage.scripts?.line_tag || "",
                custom: this.salePage.scripts?.custom || ""
            }
        };
    },
    created() {},

    methods: {
        store() {
            this.$swal({
                icon: "warning",
                title: "ต้องการบันทึกข้อมูลการตลาด ใช่ไหม?",
                text: "เมื่อกดยืนยัน ข้อมูลการตลาด จะถูกบันทึก",
                confirmButtonText: "ยืนยัน",
                showCancelButton: true,
                cancelButtonText: "ยกเลิก",
                reverseButtons: true
            }).then(result => {
                if (result.isConfirmed) {
                    this.loading = true;
                    axios
                        .post(
                            `/backend/s/${this.shop}/salepages/${this.salePage.id}/scripts`,
                            this.form
                        )
                        .then(res => {
                            this.loading = false;
                        })
                        .catch(err => {});
                } else if (result.isDenied) {
                }
            });
        }
    }
};
</script>
